import baseApplicationItem from './baseApplicationItem'
import moment from 'moment'
import {merge} from 'lodash'
import Vue from 'vue'

const module = {
  endpoint: 'variant',
  getNew: {
    deleted: false,
    sku: null,
    sizeType: null,
    size: '',
    color: '',
    cost: 0,
    price: 0,
    vat: null,
    currency: null,
    product: {
      year: moment().year()
    },
    sellables: [],
    quantity: 1
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'sku',
        title: 'sku',
        sortField: 'sku'
      },
      {
        name: 'quantity',
        title: 'quantità',
        sortField: 'quantity'
      },
      {
        name: 'product.name',
        title: 'Prodotto',
        sortField: 'product.name'
      },
      {
        name: 'product.year',
        title: 'Anno'
      },
      {
        name: 'size.name',
        title: 'Taglia',
        sortField: 'size.name'
      },
      {
        name: 'color',
        title: 'Colore',
        sortField: 'color'
      },
      {
        name: '__component:actions-column',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
    }
  },
  async find (filter) {
    let url = `${this.endpoint}/find?filter=${filter}`
    let variants = (await Vue.http.get(url)).body
    return variants
  }
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/variants.js